// str脱敏
const strHide = (name) => {
    let newStr = ''
    const char = '****'
    if (name.length >= 2) {
        newStr = name.substr(0, 1) + char + name.substr(-1, 1)
    } else {
        newStr = name + char
    }
    return newStr
}

export default strHide